// 记账完整性数据
export const accountIntegrity = [
  { key:'bill_list', name: '票据清单',path: "./pageInvoice" },
  { key:'voucher_number_interruption', name: '凭证断号',path: "./examine" },
  {
    key:'fixed_assets_parent',
    name: '固定资产账卡核对',
    path: "./fixedAssets",
    children:[
      { key:'fixed_assets', name: '资产原值',path: "./fixedAssets"},
      { key:'fixed_depreciation', name: '累计折旧',path: "./fixedAssets"},
    ]
  },
  { key:'balance_sheet', name: '资产负债表平衡',path: "./balanceSheet" },
  { key:'report_relationship', name: '报表勾稽关系'},
  { key:'bank_statements', name: '银行流水',path: "./subsidiaryLedger", query: { subjectId: '8367029614172676096' }  },
]



// 税务指标检测数据
export const taxIndex = [
  { key:'nil_return', name: '零申报',path: "./profitStatement" },
  { key:'profit_loss_year', name: '本年利润',path: "./profitStatement" },
  { key:'excessive_inventory_balance', name: '库存余额',path: "./balanceSheet" },
  {
    key:'abnormal_monetary_funds',
    name: '货币资金',
    path: "./subsidiaryLedger",
    query: { subjectId: '8367029614072012800' },
    children:[
      { key:'cash_in_hand', name: '库存现金',path: "./subsidiaryLedger", query: { subjectId: '8367029614072012800' } },
      { key:'bank_deposits', name: '银行存款',path: "./subsidiaryLedger", query: { subjectId: '8367029614072012800' } },
      { key:'other_monetary_funds', name: '其他货币资金',path: "./subsidiaryLedger", query: { subjectId: '8367029614172676096' } },
    ]
  },
]

// 财务指标检测 数据
export const financialIndex = [
  { key:'advertising_business_promotion', name: '广告费和业务宣传费明细占比分析',path: "./subjectBalance" },
  { key:'business_entertainment_expenses', name: '业务招待费占营业收入比值分析',path: "./subjectBalance" },
  { key:'welfare_expenses_operating_income', name: '福利费占营业收入比值分析',path: "./subjectBalance" },
  { key:'analysis_service_operating_revenue', name: '服务费占营业收入比值分析',path: "./subjectBalance" },
  { key:'travel_expenses', name: '差旅费',path: "./subjectBalance" },
  { key:'matching_transportation_fixed_assets', name: '交通和固定资产匹配',path: "./subjectBalance" },
]
// 经营指标分析数据
export const operateIndex = [
  { key:'gross_margin', name: '毛利率',path: "./profitStatement" },
  { key:'asset_liability_ratio', name: '资产负债率',path: "./balanceSheet" },
  { key:'profit_margin', name: '利润率',path: "./profitStatement" },
]

// 重要节点提示 数据--- 小规模企业
export const importantNode_s = [
  { key:'income_consecutive_months', name: '连续12个月收入不超过500万元',tipText: '小规模连续12个月收入超过 450万元，会预警提示',path: "./profitStatement" },
  { key:'quarterly_sales_revenue', name: '季度销售额是否超30万',tipText: '小规模季度销售额超过 25万元，会预警提示',path: "./profitStatement"  },
  { key:'duty_employees', name: '在职职工超30人',tipText: '在职职工超过30人，会预警提示',path: "./staff"  },
  { key:'annual_taxable_income', name: '年度应纳税所得额不超过300万元',tipText: '年度应纳税所得额超过 270万元，会预警提示',path: "./profitStatement"  },
  { key:'total_assets', name: '资产总额不超过5000万元',tipText: '资产总额超过 4500万元，会预警提示',path: "./balanceSheet"  },
]
// 重要节点提示 数据--- 一般纳税人
export const importantNode_m = [
  { key:'duty_employees', name: '在职职工超30人',tipText: '在职职工超过 30人，会预警提示',path: "./staff"  },
  { key:'annual_taxable_income', name: '年度应纳税所得额不超过300万元',tipText: '年度应纳税所得额超过 270万元，会预警提示',path: "./profitStatement"  },
  { key:'total_assets', name: '资产总额不超过5000万元',tipText: '资产总额超过 4500万元，会预警提示',path: "./balanceSheet"  },
]



// WEBPACK FOOTER //
// ./src/pages/physical_report/dataBase.js